<template>
  <div class="d-flex flex-column mb-3 border-bottom pb-3">
    <span class="font-weight-bolder mb-2">{{ $t('approves.title') }}</span>

    <empty-listing
      v-if="
        !mergeRequestApprovedBy ||
        (mergeRequestApprovedBy.approvers && mergeRequestApprovedBy.approvers.length < 1)
      "
      :title="$t('approves.not_approved')"
      type="small"
    />

    <div
      v-else
      class="approvers-list d-flex flex-wrap"
    >
      <user-label-item
        v-for="user in mergeRequestApprovedBy.approvers"
        :key="user.id"
        :image-size="22"
        :show-tooltip="true"
        :has-user-link="true"
        :show-name="false"
        :user="user"
        tooltip-prefix="total-prefix-approves"
      />
    </div>
    <div
      v-if="
        hasAccess &&
        mergeRequestStatus &&
        !['CLOSED', 'MERGED', 'CANCELED'].includes(mergeRequestStatus.id)
      "
      class="mt-3"
    >
      <button
        class="btn w-100 btn-sm"
        type="button"
        :class="approved ? 'btn-danger' : 'btn-primary'"
        @click.prevent="approveEvent"
      >
        {{ approved ? $t('approves.cancel_approve') : $t('approves.approve') }}
      </button>
    </div>
  </div>
</template>

<script>
import EmptyListing from '@shared/shared-components/empty-listing';
import UserLabelItem from '@shared/shared-components/shared/user-label-item';
import MergeReqApproverS from '@/shared-modules/modules/merge-request-approver/merge-request-approver.service';
import MergeRequestService from '@shared/services/merge-request.service';
import langMessages from '@/shared-modules/modules/merge-request-approver/merge-request-approval.messages';
import ACTION_ENUM from "@shared/modules/custom-roles/custom-roles.constants";

export default {
  name: 'MergeRequestApprovers',
  components: { UserLabelItem, EmptyListing },
  props: {
    hasAccess: {
      default: false,
      type: Boolean
    },
    mergeRequestStatus: {
      default: null,
      type: Object
    }
  },
  data() {
    return { approved: false };
  },
  computed: {
    mergeRequestApprovedBy() {
      return this.$store.getters.getMergeRequestApprovedBy;
    },
    applicationVersion() {
      return this.$store.getters.getApplicationVersion;
    }
  },
  mounted() {
    MergeReqApproverS.getMergeRequestApprovedBy(
      this.$route.params.alias,
      this.$route.params.projectAlias,
      this.$route.params.id
    );

    if (this.hasAccess) {
      MergeReqApproverS.getMergeRequestApprovedByMe(
        this.$route.params.alias,
        this.$route.params.projectAlias,
        this.$route.params.id
      ).then((res) => {
        this.approved = res.approved;
      });
    }
  },
  methods: {
    approveEvent() {
      MergeReqApproverS.approveRequest(
        this.$route.params.alias,
        this.$route.params.projectAlias,
        this.$route.params.id
      ).then(() => {
        this.approved = !this.approved;
        MergeReqApproverS.getMergeRequestApprovedBy(
          this.$route.params.alias,
          this.$route.params.projectAlias,
          this.$route.params.id
        );
        if (this.applicationVersion !== 'onpremise') {
          MergeRequestService.getMergeRequestCodeOwners(
            this.$route.params.alias,
            this.$route.params.projectAlias,
            this.$route.params.id
          );
        }
        this.$emit('approveAction', this.approved);
      });
    }
  },
  i18n: {
    messages: langMessages
  }
};
</script>

<style lang="scss" scoped>
.approvers-list {
  &:hover {
    > *:not(:first-child) {
      margin-left: 0;
    }
  }

  & > * {
    transition: all 0.3s ease;
    position: relative;
    top: 0;

    &:not(:first-child) {
      margin-left: -10px;
    }

    &:hover {
      z-index: 1;
      top: -4px;
    }
  }
}
</style>
